import { CMSHeaderLayoutClasses } from "../header/siteHeader/cmsSiteHeader.layout";
import { scrollToHash } from "./html";

function openAllDetails() {
  const allDetails = document.querySelectorAll('details');
  allDetails.forEach((v, k) => {
    if(v.open) { v.dataset.open = '1'; }
    else { v.setAttribute('open', ''); }
  })
}

function closeAllDetails() {
  const allDetails = document.querySelectorAll('details');
    allDetails.forEach((v, k) => {
      if(v.dataset.open) { v.dataset.open = ''; }
      else { v.removeAttribute('open'); }
    })
}

function openHashLinkExpand(anchor: string) {
  const hashedExpand = document.querySelector(anchor)
  if(hashedExpand == null) return;
  
  hashedExpand.closest('details')?.setAttribute('open', '');
}

function handleHashLink(url: string|null) {
  if(url == null) return;
  if(url.substring(0, 1) !== '/') return; // ONLY CONTINUE ON IF INTERNAL URL!
    
  const urlObj:URL = new URL(url, window.location.origin);
  if(urlObj.hash == "") return; // ONLY CONTINUE ON IF URL HAS HASH!

  const currentUrl: string = window.location.pathname + window.location.hash;
  if(currentUrl == url) { // ONLY CONTINUE ON IF URL IS EQUAL TO CURRENT PAGE!
    openHashLinkExpand(urlObj.hash)
    scrollToHash()
  }
}

function handleHashLinkClick(e:MouseEvent) {
  const clickedEl = (e.target instanceof HTMLElement) ? e.target : null;
  if(clickedEl == null) return;
  
  if(clickedEl.tagName == 'A') {
    handleHashLink(clickedEl.getAttribute('href'));
  } else {
    const parentEl:HTMLElement|null = clickedEl.closest('[href]');
    if(parentEl == null) return;

    if(parentEl.tagName == 'A') {
      handleHashLink(parentEl.getAttribute('href'));
    }
  }
}

function closeMenuOnEscape(e: KeyboardEvent, callback: () => void) {
  if (e.key === 'Escape' && document.documentElement.classList.contains(CMSHeaderLayoutClasses.navOpen)) {
    callback();
  }
}

function closePopupOnEscape(e: KeyboardEvent, callback: () => void) {
  if (e.key === 'Escape') {
    callback();
  }
}

export function addWindowEvents(props: { type: 'global' } | { type: 'header', callback: () => void } | { type: 'popup', callback: () => void }) {
  if(props.type == 'header') {
    window.addEventListener('keyup', (e) => closeMenuOnEscape(e, props.callback));
  } else if(props.type == 'popup') {
    window.addEventListener('keyup', (e) => closePopupOnEscape(e, props.callback));
  } else {
    window.addEventListener('beforeprint', openAllDetails);
    window.addEventListener('afterprint', closeAllDetails);

    window.addEventListener('click', handleHashLinkClick);
  }
}

export function removeWindowEvents(props: { type: 'global' } | { type: 'header', callback: () => void } | { type: 'popup', callback: () => void }) {
  if(props.type == 'header') {
    window.removeEventListener('keyup', (e) => closeMenuOnEscape(e, props.callback));
  } else if(props.type == 'popup') {
    window.removeEventListener('keyup', (e) => closePopupOnEscape(e, props.callback));
  } else {
    window.removeEventListener('beforeprint', openAllDetails);
    window.removeEventListener('afterprint', closeAllDetails);
    
    window.removeEventListener('click', handleHashLinkClick);
  }
}
